import { CanAssignValidationProvider } from 'components/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/CanAssignValidation.validation.context';
import { ConfirmAvailabilityModalComponent } from 'components/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/ConfirmAvailabilityModal.component';

export const ConfirmAvailabilityModal = () => (
  <CanAssignValidationProvider>
    <ConfirmAvailabilityModalComponent />
  </CanAssignValidationProvider>
);
